module.exports = __webpack_public_path__ + "img/1440.5e763cb1.svg";